import { useQuery } from "@tanstack/react-query";

import type { PortableTextBlock } from "@/api/queries";

import useAppStore from "../../../store/appStateZustand";
import client from "../client";

export type OpportunityItem = {
  _type: string;
  _id: string;
  name: string;
  description: PortableTextBlock | PortableTextBlock[];
  altText: string;
  imageUrl: string;
  url?: string;
};

export type OpportunitiesAvailableResult = {
  opportunities_available: OpportunityItem[];
};

export type OpportunitiesQueryResult = OpportunityItem[] | OpportunitiesAvailableResult;

async function getOpportunities(allOpportunitiesAvailable: boolean | null): Promise<OpportunitiesQueryResult> {
  const catalogueCode = useAppStore.getState().selectedCatalogue as string;
  const domain = window.location.origin;

  const allOppsQuery = `*[_type == "opportunities"]{_type, _id, name, description, "altText": image.altText,"imageUrl": image.asset->url, url}`;

  const availableOppsQuery = `*[_type == 'siteConfiguration' && ($catalogueCode in catalogueConfig.catalogue_codes || $domain in domainConfig.domain)][0]{'opportunities_available': syncsAndOpportunities.opportunitiesAvailable[]->{_type, _id, name, description, "altText": image.altText,"imageUrl": image.asset->url, url}}`;

  try {
    if (allOpportunitiesAvailable === true) {
      return await client.fetch<OpportunityItem[]>(allOppsQuery);
    }
    return await client.fetch<OpportunitiesAvailableResult>(availableOppsQuery, { catalogueCode, domain });
  }
  catch (error) {
    console.error("Error fetching Opportunities data:", error);
    throw error;
  }
}

function useOpportunitiesQuery() {
  const allOpportunitiesAvailable = useAppStore(state => state.allOpportunitiesAvailable);

  return useQuery<OpportunitiesQueryResult>({
    queryKey: ["opps", allOpportunitiesAvailable],
    queryFn: async () => getOpportunities(allOpportunitiesAvailable as unknown as boolean | null),
    staleTime: 120000,
  });
}

export default useOpportunitiesQuery;
